import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { PhotoView } from 'react-photo-view';
import {
  IconCalendarTime,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconReload,
  IconSearch,
  IconBuildingStore,
  IconDiamond,
  IconScale,
  IconPhoto,
  IconInbox,
  IconLoader2,
  IconReceipt2,
  IconLayoutGrid,
  IconX,
} from '@tabler/icons-react';

import { getAuthorizationHeader, http } from '../../config/http';
import Layouts from '../../layouts/Layouts';
import { DinamicTitle } from '../../utils/DinamicTitle';
import DetailTransaksiPembelian from '../Transaksi/DetailTransaksiPembelian';
import EditTrxPembelian from '../Transaksi/EditTrxPembelian';
import ConfirmationDeletePembelian from '../../components/Admin/ConfirmationDeletePembelian';
import useKarat from '../features/useKarat';
import { resolveItemImageUrl } from '../../utils/itemImage';

const GaleriPembelian = () => {
  DinamicTitle('Galeri Pembelian || Komaladewi');
  const navigate = useNavigate();

  // Core & Data States
  const [trxPembelian, setTrxPembelian] = useState([]);
  const [detailPembelian, setDetailPembelian] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState('');

  // Filter States
  const [idCabang, setIdCabang] = useState('');
  const [selectCabang, setSelectCabang] = useState([]);
  const [kategori, setKategori] = useState([]);
  const [selectedKategori, setSelectedKategori] = useState('');
  const [selectJenisKategori, setSelectJenisKategori] = useState('');
  const { karatOption, karatOptionId, setKaratOptionId } = useKarat();
  const [berat, setBerat] = useState('');
  const [gridCols, setGridCols] = useState('4');

  // Date Range Filter States
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const datePickerRef = useRef(null);

  const awal = startDate ? moment(startDate).format('DD-MM-YYYY') : '';
  const akhir = endDate ? moment(endDate).format('DD-MM-YYYY') : '';

  const selectionRange = {
    startDate: startDate || new Date(),
    endDate: endDate || new Date(),
    key: 'selection',
  };

  const handleSelect = (ranges) => {
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  };

  // Outside click listener for DatePicker Popover
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (datePickerRef.current && !datePickerRef.current.contains(e.target)) {
        setShowDatePicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Detail Modal States
  const [show, setShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [submitChange, setSubmitChange] = useState(false);
  const [pembelian_id, setIdTrxPembelian] = useState('');
  const [kodeTransaksi, setKodeTransaksi] = useState('');
  const [teknisi_id, setTeknisi] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isSubmitBarangOpname, setIsSubmitBarangOpname] = useState(false);

  // Edit Modal States
  const [isOpenEditTrx, setIsOpenEditTrx] = useState(false);
  const [loadingEditPembelian, setLoadingEditPembelian] = useState(false);
  const [submitPembelian, setSubmitPembelian] = useState(false);
  const [isSubmitEdit, setIsSubmitEdit] = useState(false);
  const [idEdit, setIdEdit] = useState('');
  const [karat, setKarat] = useState('');
  const [kondisi_barang, setKondisiBarang] = useState('');
  const [harga_beli, setHargaBeli] = useState('');
  const [jenis_kategori_id, setJenisKategoriIdBase] = useState('');
  const [is_change_harga, setIsChange] = useState(false);
  const [gambar, setGambar] = useState(null);
  const [idEditPembelian, setIdEditPembelian] = useState([]);
  const [isSelected, setIsSelected] = useState(false);
  const [editBerat, setEditBerat] = useState('');

  // Delete Modal States
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [loadingDel, setLoadingDel] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [pembelianDelete, setPembelianDelete] = useState([]);
  const [isDelete, setIsDelete] = useState(false);

  function numberWithCommas(x) {
    if (x === undefined || x === null || x === '') return '0';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ---------------------------------------------------------------------------
  // API Fetching
  // ---------------------------------------------------------------------------
  async function getTrxPembelian(overrideQuery = null) {
    setLoading(true);
    try {
      let query;
      if (typeof overrideQuery === 'string') {
        query = overrideQuery;
      } else {
        query = `${search === '' ? `?page=${currentPage}` : `?faktur=${search}`}${
          idCabang === '' ? '' : `&cabang=${idCabang}`
        }${
          selectedKategori === '' ? '' : `&kategori=${selectedKategori}`
        }${
          selectJenisKategori === '' ? '' : `&jenis_kategori=${selectJenisKategori}`
        }${
          startDate === null && endDate === null ? '' : `&tgl_awal=${awal}&tgl_akhir=${akhir}`
        }${karatOptionId === '' ? '' : `&karat=${karatOptionId}`}${
          berat === '' ? '' : `&berat=${berat}`
        }`;
      }

      const res = await http.get(`pembelian${query}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setLastPage(res.data?.data?.last_page || 1);
      setCurrentPage(res.data?.data?.current_page || 1);
      setTotalItems(res.data?.data?.total || (res.data?.data?.data ? res.data.data.data.length : 0));
      setTrxPembelian(res.data?.data?.data || []);
    } catch (err) {
      if (err.response?.status === 401) {
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  }

  const handleReload = () => {
    setIdCabang('');
    setSelectedKategori('');
    setSelectJenisKategori('');
    setKaratOptionId('');
    setSearch('');
    setStartDate(null);
    setEndDate(null);
    setBerat('');
    setCurrentPage(1);
    getTrxPembelian('?page=1');
  };

  // Debounced fetch on filter/search changes
  useEffect(() => {
    const timer = setTimeout(() => {
      getTrxPembelian();
    }, 350);
    return () => clearTimeout(timer);
  }, [
    isSubmit,
    isSubmitEdit,
    idCabang,
    search,
    currentPage,
    startDate,
    endDate,
    selectedKategori,
    selectJenisKategori,
    karatOptionId,
    berat,
  ]);

  // Fetch Cabang & Kategori Filters
  useEffect(() => {
    async function getCabangSelect() {
      try {
        const res = await http.get('cabang?is_toko=1', {
          headers: { Authorization: getAuthorizationHeader() },
        });
        setSelectCabang(res.data.data || []);
      } catch (err) {
        if (err.response?.status === 401) navigate('/login');
      }
    }

    async function getKategori() {
      try {
        const res = await http.get('/kategori', {
          headers: { Authorization: getAuthorizationHeader() },
        });
        setKategori(res.data || []);
      } catch (err) {
        if (err.response?.status === 401) navigate('/login');
      }
    }

    getCabangSelect();
    getKategori();
  }, [navigate]);

  // ---------------------------------------------------------------------------
  // Action Handlers
  // ---------------------------------------------------------------------------
  const handleKategoriChange = (e) => {
    setSelectedKategori(e.target.value);
    setSelectJenisKategori('');
  };

  const handleJenisKategoriChange = (e) => {
    setSelectJenisKategori(e.target.value);
  };

  // Detail Transaksi
  async function getIdPembelian(id) {
    setShow(true);
    setSubmitChange(true);
    try {
      const res = await http.get(`/pembelian/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setKodeTransaksi(res.data.data.kode_trx);
      setIdTrxPembelian(res.data.data.id);
      setDetailPembelian(res.data.data);
      setIsOpen(true);
    } catch (err) {
      console.error(err);
      toast.error('Gagal mengambil detail pembelian');
    } finally {
      setSubmitChange(false);
      setShow(false);
    }
  }

  // Stok Opname
  async function addToOpname() {
    const data = { pembelian_id, teknisi_id };
    setIsSubmitBarangOpname(true);
    try {
      const response = await http.post(`/stok-opname`, data, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setIsOpen(false);
      setIsSubmit(true);
      toast.success(response.data.message || 'Berhasil masuk stok opname', { autoClose: 600 });
    } catch (error) {
      if (error.response?.status === 409) {
        toast.error(error.response.data.message, { autoClose: 600 });
      } else if (error.response?.status === 422) {
        toast.warning('Silahkan masukkan teknisi', { autoClose: 600 });
      } else {
        toast.error('Gagal memproses stok opname');
      }
    } finally {
      setIsSubmitBarangOpname(false);
    }
  }

  // Edit Transaksi
  // eslint-disable-next-line no-unused-vars
  async function getIdEditPembelian(id) {
    setLoadingEditPembelian(true);
    try {
      const res = await http.get(`/pembelian/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setJenisKategoriIdBase(res.data.data.jenis_kategori_id);
      setIdEditPembelian(res.data.data);
      setIdEdit(res.data.data.id);
      setEditBerat(res.data.data.berat);
      setHargaBeli(res.data.data.harga_beli);
      setKarat(res.data.data.karat);
      setKondisiBarang(res.data.data.kondisi_barang);
      setGambar(res.data.data.gambar?.[0]?.asli || null);
      setIsOpenEditTrx(true);
    } catch (err) {
      if (err.response?.status === 422) {
        toast.warning('Periksa data yang diubah', { autoClose: 600 });
      }
      console.error(err);
    } finally {
      setLoadingEditPembelian(false);
    }
  }

  async function editTrxPembelian(e) {
    e.preventDefault();
    setSubmitPembelian(true);
    setIsSubmitEdit(true);

    try {
      const data = {
        berat: editBerat,
        harga_beli,
        karat,
        gambar,
        jenis_kategori_id,
        is_change_harga,
        kondisi_barang,
      };
      const response = await http.put(`pembelian/${idEdit}`, data, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      toast.success(response.data.message || 'Data berhasil diupdate', { autoClose: 600 });
      setIsOpenEditTrx(false);
      setSubmitPembelian(false);
      setIsSelected(false);
      getTrxPembelian();
    } catch (error) {
      if (error.code === 'ECONNABORTED') {
        toast.warning('Waktu permintaan ke server habis', { autoClose: 600 });
      } else {
        console.error(error);
        toast.error(error.response?.data?.message || 'Gagal mengubah pembelian');
      }
    } finally {
      setTimeout(() => {
        setSubmitPembelian(false);
        setIsSubmitEdit(false);
      }, 800);
    }
  }

  // Delete Transaksi
  // eslint-disable-next-line no-unused-vars
  async function getIdDelete(id) {
    setLoadingDel(true);
    try {
      const res = await http.get(`pembelian/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setDeleteId(res.data.data.id);
      setPembelianDelete(res.data.data);
      setIsOpenModalDelete(true);
    } catch (err) {
      console.error(err);
      toast.error('Gagal memuat data pembelian');
    } finally {
      setLoadingDel(false);
    }
  }

  async function deletePembelian(alasan = 'Salah input data', keterangan = '') {
    setIsDelete(true);
    try {
      const res = await http.delete(`pembelian/${deleteId}`, {
        data: { alasan, keterangan },
        params: { alasan, keterangan },
        headers: { Authorization: getAuthorizationHeader() },
      });
      setIsOpenModalDelete(false);
      toast.success(res.data.message || 'Berhasil memproses penghapusan pembelian', {
        autoClose: 1500,
      });
      getTrxPembelian();
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || 'Gagal menghapus pembelian');
    } finally {
      setIsDelete(false);
    }
  }

  // Summary Metrics for current page (exclude refunded transactions)
  const totalHargaPage = trxPembelian
    .filter((curr) => !curr?.is_refund)
    .reduce(
      (acc, curr) => acc + (parseFloat(curr?.total_harga || curr?.harga_beli) || 0),
      0
    );
  const totalBeratPage = trxPembelian
    .filter((curr) => !curr?.is_refund)
    .reduce(
      (acc, curr) => acc + (parseFloat(curr?.berat) || 0),
      0
    );

  const [updatingId, setUpdatingId] = useState(null);

  const normalizeKondisi = (val) => {
    if (!val) return 'Ready Jual';
    const lower = val.toString().toLowerCase().trim();
    if (lower.includes('service') || lower.includes('servis')) return 'Service';
    if (lower.includes('rongsok') || lower.includes('rusak') || lower.includes('lebur')) return 'Rongsok';
    if (lower.includes('ready') || lower.includes('jual') || lower.includes('bagus')) return 'Ready Jual';
    return val;
  };

  const getKondisiBadgeStyle = (val) => {
    const norm = normalizeKondisi(val);
    switch (norm) {
      case 'Ready Jual':
        return 'bg-emerald-50 dark:bg-emerald-950/40 text-emerald-700 dark:text-emerald-300 border-emerald-300 dark:border-emerald-800 hover:border-emerald-400';
      case 'Service':
        return 'bg-sky-50 dark:bg-sky-950/40 text-sky-700 dark:text-sky-300 border-sky-300 dark:border-sky-800 hover:border-sky-400';
      case 'Rongsok':
        return 'bg-rose-50 dark:bg-rose-950/40 text-rose-700 dark:text-rose-300 border-rose-300 dark:border-rose-800 hover:border-rose-400';
      default:
        return 'bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-300 border-amber-300 dark:border-amber-800';
    }
  };

  async function handleKondisiChange(trx, newKondisi) {
    if (!trx || !trx.id || trx.kondisi_barang === newKondisi) return;
    setUpdatingId(trx.id);
    try {
      const res = await http.get(`/pembelian/${trx.id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      const current = res.data.data;
      const payload = {
        berat: current.berat,
        harga_beli: current.harga_beli,
        karat: current.karat,
        gambar: null,
        jenis_kategori_id: current.jenis_kategori_id,
        is_change_harga: false,
        kondisi_barang: newKondisi,
      };
      await http.put(`pembelian/${trx.id}`, payload, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      toast.success(`Kondisi barang berhasil diubah ke "${newKondisi}"`, { autoClose: 1200 });
      setTrxPembelian((prev) =>
        prev.map((item) => (item.id === trx.id ? { ...item, kondisi_barang: newKondisi } : item))
      );
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || 'Gagal mengubah kondisi barang');
    } finally {
      setUpdatingId(null);
    }
  }

  return (
    <Layouts //title="Galeri Pembelian"
    >
      <div className="p-3 sm:p-5 lg:p-6 w-full space-y-4 flex-1 flex flex-col">
        {/* Detail Modal */}
        <DetailTransaksiPembelian
          kodeTransaksi={kodeTransaksi}
          kategori={kategori}
          isSubmitBarangOpname={isSubmitBarangOpname}
          submitChange={submitChange}
          detailPembelian={detailPembelian}
          addToOpname={addToOpname}
          handleOnChangeTeknisi={(e) => setTeknisi(e.target.value)}
          closeModal={() => setIsOpen(false)}
          isOpen={isOpen}
        />

        {/* Edit Modal */}
        <EditTrxPembelian
          idEditPembelian={idEditPembelian}
          submitPembelian={submitPembelian}
          setJenisKategoriIdBase={setJenisKategoriIdBase}
          setIsChange={setIsChange}
          isSelected={isSelected}
          setIsSelected={setIsSelected}
          gambar={gambar}
          setGambar={setGambar}
          is_change_harga={is_change_harga}
          editTrxPembelian={editTrxPembelian}
          berat={editBerat}
          setBerat={setEditBerat}
          karat={karat}
          setKarat={setKarat}
          setKondisiBarang={setKondisiBarang}
          harga_beli={harga_beli}
          setHargaBeli={setHargaBeli}
          isOpenEditTrx={isOpenEditTrx}
          closeModalEditTrx={() => setIsOpenEditTrx(false)}
        />

        {/* Delete Modal */}
        <ConfirmationDeletePembelian
          isDelete={isDelete}
          deletePembelian={deletePembelian}
          pembelianDelete={pembelianDelete}
          isOpenModalDelete={isOpenModalDelete}
          closeModalDelete={() => setIsOpenModalDelete(false)}
        />

        {/* Global Loading Overlay */}
        {(show || loadingDel || loadingEditPembelian) && (
          <div className="fixed inset-0 z-50 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center">
            <div className="bg-white dark:bg-slate-800 p-5 rounded-2xl shadow-xl flex items-center gap-3">
              <IconLoader2 size={24} className="animate-spin text-amber-500" />
              <span className="text-sm font-semibold text-slate-800 dark:text-slate-100">
                Memproses data...
              </span>
            </div>
          </div>
        )}

        {/* ========================================================================= */}
        {/* GOLD THEME FILTER & ACTION TOOLBAR                                       */}
        {/* ========================================================================= */}
        <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 shadow-sm rounded-2xl p-3 sm:p-4">
          <div className="flex items-center gap-2.5 overflow-x-auto pb-1 custom-scrollbar">
            {/* PENCARIAN NO FAKTUR PEMBELIAN */}
            <div className="min-w-[170px] sm:min-w-[210px] flex-1">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Pencarian
              </label>
              <div className="relative">
                <IconSearch
                  size={15}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"
                />
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Cari No. Faktur Pembelian..."
                  className="w-full pl-9 pr-3 py-2 text-xs font-semibold bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition shadow-sm"
                />
              </div>
            </div>

            {/* RENTANG TANGGAL FILTER */}
            <div className="min-w-[150px] sm:min-w-[170px]">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Rentang Tanggal
              </label>
              <div className="relative" ref={datePickerRef}>
                <button
                  type="button"
                  onClick={() => setShowDatePicker(!showDatePicker)}
                  className={`w-full px-3 py-2 rounded-xl border text-xs font-semibold transition-all flex items-center justify-between gap-1.5 cursor-pointer shadow-sm ${
                    startDate && endDate
                      ? 'bg-amber-500 text-white border-amber-600 shadow-amber-500/20'
                      : 'bg-slate-50 dark:bg-slate-800/80 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700 hover:border-amber-400'
                  }`}
                  title="Filter Rentang Tanggal"
                >
                  <div className="flex items-center gap-1.5 truncate">
                    <IconCalendarTime size={15} className={startDate && endDate ? 'text-white' : 'text-amber-600 dark:text-amber-400'} />
                    <span className="truncate">
                      {startDate && endDate
                        ? `${moment(startDate).format('DD/MM')} - ${moment(endDate).format('DD/MM')}`
                        : 'Semua Tanggal'}
                    </span>
                  </div>
                </button>
                {showDatePicker && (
                  <div
                    className="fixed inset-0 z-[9999] flex items-center justify-center p-3 sm:p-4 bg-slate-900/60 backdrop-blur-xs"
                    onClick={(e) => {
                      if (e.target === e.currentTarget) setShowDatePicker(false);
                    }}
                  >
                    <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-800 p-3 sm:p-4 max-w-sm sm:max-w-md w-full overflow-hidden">
                      <div className="flex items-center justify-between pb-3 mb-2 border-b border-slate-100 dark:border-slate-800">
                        <div className="flex items-center gap-2">
                          <IconCalendarTime size={18} className="text-amber-500" />
                          <h3 className="font-bold text-sm text-slate-800 dark:text-slate-100">
                            Pilih Rentang Tanggal
                          </h3>
                        </div>
                        <button
                          type="button"
                          onClick={() => setShowDatePicker(false)}
                          className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 p-1 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition cursor-pointer"
                        >
                          <IconX size={18} />
                        </button>
                      </div>

                      <div className="flex justify-center overflow-x-auto py-1">
                        <DateRange
                          ranges={[selectionRange]}
                          onChange={handleSelect}
                          moveRangeOnFirstSelection={false}
                          rangeColors={['#f59e0b']}
                        />
                      </div>

                      <div className="flex items-center justify-between gap-2 pt-3 mt-2 border-t border-slate-100 dark:border-slate-800">
                        <button
                          type="button"
                          onClick={() => {
                            setStartDate(null);
                            setEndDate(null);
                            setShowDatePicker(false);
                          }}
                          className="px-3 py-1.5 text-xs font-semibold text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/40 rounded-lg transition cursor-pointer"
                        >
                          Reset Tanggal
                        </button>
                        <div className="flex items-center gap-2">
                          <button
                            type="button"
                            onClick={() => setShowDatePicker(false)}
                            className="px-3 py-1.5 text-xs font-semibold text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition cursor-pointer"
                          >
                            Batal
                          </button>
                          <button
                            type="button"
                            onClick={() => setShowDatePicker(false)}
                            className="px-4 py-1.5 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-xs font-bold transition shadow-sm cursor-pointer"
                          >
                            Terapkan
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* ETALASE / CABANG SELECT */}
            <div className="min-w-[130px] sm:min-w-[150px]">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Etalase / Toko
              </label>
              <div className="relative">
                <select
                  value={idCabang}
                  onChange={(e) => {
                    setIdCabang(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="w-full text-xs font-semibold bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 rounded-xl px-3 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition cursor-pointer appearance-none"
                >
                  <option value="">Semua Etalase</option>
                  {selectCabang.map((cb) => (
                    <option value={cb.id} key={cb.id}>
                      {cb.nama_cabang}
                    </option>
                  ))}
                </select>
                <div className="absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
                  <IconBuildingStore size={14} />
                </div>
              </div>
            </div>

            {/* KATEGORI SELECT */}
            <div className="min-w-[120px] sm:min-w-[140px]">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Kategori
              </label>
              <select
                value={selectedKategori}
                onChange={(e) => {
                  handleKategoriChange(e);
                  setCurrentPage(1);
                }}
                className="w-full text-xs font-semibold bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition cursor-pointer"
              >
                <option value="">Semua Kategori</option>
                {kategori.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.nama_kategori}
                  </option>
                ))}
              </select>
            </div>

            {/* JENIS KATEGORI SELECT (DEPENDENT) */}
            {selectedKategori && (
              <div className="min-w-[130px] sm:min-w-[150px] animate-in fade-in">
                <label className="block text-[10px] font-bold text-amber-700 dark:text-amber-400 uppercase tracking-wider mb-1">
                  Jenis Kategori
                </label>
                <select
                  value={selectJenisKategori}
                  onChange={(e) => {
                    handleJenisKategoriChange(e);
                    setCurrentPage(1);
                  }}
                  className="w-full text-xs font-semibold bg-amber-50 dark:bg-amber-950/30 border border-amber-300 dark:border-amber-800 rounded-xl px-3 py-2 text-amber-900 dark:text-amber-300 focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition cursor-pointer"
                >
                  <option value="">Semua Jenis</option>
                  {kategori
                    .find((kt) => String(kt.id) === String(selectedKategori))
                    ?.jenis_kategori?.map((jk) => (
                      <option key={jk.id} value={jk.id}>
                        {jk.nama_jenis}
                      </option>
                    ))}
                </select>
              </div>
            )}

            {/* KARAT SELECT */}
            <div className="min-w-[100px] sm:min-w-[115px]">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Karat
              </label>
              <div className="relative">
                <select
                  value={karatOptionId}
                  onChange={(e) => {
                    setKaratOptionId(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="w-full text-xs font-semibold bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 rounded-xl px-3 py-2 pr-7 focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition cursor-pointer appearance-none"
                >
                  <option value="">Semua Karat</option>
                  {karatOption.map((kto) => (
                    <option key={kto} value={kto}>
                      {kto} K
                    </option>
                  ))}
                </select>
                <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
                  <IconDiamond size={13} />
                </div>
              </div>
            </div>

            {/* RELOAD BUTTON (API ONLY, PAGE 1, EMPTY FILTER) */}
            <div className="flex flex-col justify-end">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1 opacity-0 pointer-events-none hidden sm:block">
                Reload
              </label>
              <button
                type="button"
                onClick={handleReload}
                disabled={loading}
                className="h-[36px] px-3 bg-amber-500 hover:bg-amber-600 active:scale-95 text-white rounded-xl text-xs font-semibold transition-all flex items-center gap-1.5 shadow-sm shadow-amber-500/20 cursor-pointer disabled:opacity-50"
                title="Muat Ulang API (Kembali ke Hal 1 & Reset Filter)"
              >
                <IconReload size={15} className={loading ? 'animate-spin' : ''} />
                <span className="hidden sm:inline">Reload</span>
              </button>
            </div>

            {/* RESET FILTERS BUTTON */}
            {(idCabang || selectedKategori || selectJenisKategori || karatOptionId || search || startDate) && (
              <div className="flex flex-col justify-end">
                <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1 opacity-0 pointer-events-none hidden sm:block">
                  Reset
                </label>
                <button
                  type="button"
                  onClick={handleReload}
                  className="h-[36px] px-3 text-xs font-bold text-rose-500 hover:text-rose-600 bg-rose-50 dark:bg-rose-950/40 hover:bg-rose-100 rounded-xl transition cursor-pointer"
                  title="Reset Semua Filter"
                >
                  Reset
                </button>
              </div>
            )}

            {/* PILIHAN UKURAN TAMPILAN FOTO / GRID */}
            <div className="flex flex-col justify-end ml-auto">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Ukuran Foto
              </label>
              <div className="flex items-center bg-slate-100 dark:bg-slate-800 p-0.5 rounded-xl border border-slate-200 dark:border-slate-700 h-[36px]">
                <button
                  type="button"
                  onClick={() => {
                    setGridCols('2');
                    localStorage.setItem('galeri_grid_cols', '2');
                  }}
                  className={`px-3 py-1 rounded-lg text-xs font-bold transition-all flex items-center gap-1.5 cursor-pointer ${
                    gridCols === '2'
                      ? 'bg-amber-500 text-white shadow-sm shadow-amber-500/20'
                      : 'text-slate-600 dark:text-slate-300 hover:text-amber-600'
                  }`}
                  title="Tampilan Penuh / Besar (2 Kolom - Sangat Lebar)"
                >
                  <IconLayoutGrid size={15} />
                  <span>Besar</span>
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setGridCols('3');
                    localStorage.setItem('galeri_grid_cols', '3');
                  }}
                  className={`px-2.5 py-1 rounded-lg text-xs font-bold transition-all flex items-center gap-1 cursor-pointer ${
                    gridCols === '3'
                      ? 'bg-amber-500 text-white shadow-sm shadow-amber-500/20'
                      : 'text-slate-600 dark:text-slate-300 hover:text-amber-600'
                  }`}
                  title="Tampilan Sedang (3 Kolom)"
                >
                  <span>Sedang</span>
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setGridCols('4');
                    localStorage.setItem('galeri_grid_cols', '4');
                  }}
                  className={`px-2.5 py-1 rounded-lg text-xs font-bold transition-all flex items-center gap-1 cursor-pointer ${
                    gridCols === '4'
                      ? 'bg-amber-500 text-white shadow-sm shadow-amber-500/20'
                      : 'text-slate-600 dark:text-slate-300 hover:text-amber-600'
                  }`}
                  title="Tampilan Kompak (4 Kolom)"
                >
                  <span>Kompak</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ========================================================================= */}
        {/* GALLERY ITEMS GRID                                                        */}
        {/* ========================================================================= */}
        {loading ? (
          <div className="flex flex-col items-center justify-center p-16 bg-white dark:bg-slate-900 rounded-3xl border border-slate-200/80 dark:border-slate-800 text-center my-auto">
            <IconLoader2 size={38} className="animate-spin text-amber-500 mb-3" />
            <p className="text-sm font-semibold text-slate-600 dark:text-slate-300">
              Memuat foto transaksi pembelian...
            </p>
          </div>
        ) : trxPembelian.length === 0 ? (
          <div className="flex flex-col items-center justify-center p-16 bg-white dark:bg-slate-900 rounded-3xl border border-slate-200/80 dark:border-slate-800 text-center my-auto">
            <div className="w-16 h-16 rounded-2xl bg-amber-500/10 dark:bg-amber-400/10 border border-amber-500/20 flex items-center justify-center text-amber-600 dark:text-amber-400 mb-3">
              <IconInbox size={34} />
            </div>
            <h3 className="text-base font-bold text-slate-800 dark:text-slate-100 mb-1">
              Tidak Ada Foto Transaksi Pembelian
            </h3>
            <p className="text-xs text-slate-400 max-w-sm">
              Tidak ada data pembelian yang cocok dengan filter atau kata kunci pencarian Anda.
            </p>
          </div>
        ) : (
          <div
            className={`grid gap-4 sm:gap-6 pb-6 ${
              gridCols === '2'
                ? 'grid-cols-1 md:grid-cols-2'
                : gridCols === '3'
                ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3'
                : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4'
            }`}
          >
            {trxPembelian.map((trx, index) => {
              const item = trx?.item || trx;
              const imgUrl = resolveItemImageUrl(item);
              const storeName =
                trx?.user?.cabang?.nama_cabang || trx?.cabang?.nama_cabang || 'Etalase';
              const beratVal = parseFloat(item?.berat || trx?.berat || 0);
              const hargaBeli = parseFloat(trx?.total_harga || trx?.harga_beli || 0);
              const avgPerGram = beratVal > 0 ? Math.round(hargaBeli / beratVal) : 0;

              return (
                <div
                  key={trx.id || index}
                  className={`group relative overflow-hidden rounded-2xl border ${
                    trx?.is_refund
                      ? 'border-rose-300/80 dark:border-rose-900/60 bg-rose-50/10 dark:bg-rose-950/10'
                      : 'border-slate-200/90 dark:border-slate-800 bg-white dark:bg-slate-900'
                  } shadow-sm hover:shadow-xl hover:border-amber-500/50 transition-all duration-300 flex flex-col`}
                >
                  {/* Photo Container */}
                  <div className="relative aspect-[16/10] sm:aspect-[16/9] bg-slate-100 dark:bg-slate-800/80 overflow-hidden flex items-center justify-center cursor-pointer">
                    {imgUrl ? (
                      <PhotoView src={imgUrl}>
                        <img
                          src={imgUrl}
                          alt={trx?.kode_trx || 'Pembelian'}
                          className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ${
                            trx?.is_refund ? 'opacity-80 grayscale-[25%]' : ''
                          }`}
                        />
                      </PhotoView>
                    ) : (
                      <div className="flex flex-col items-center justify-center text-slate-400 dark:text-slate-500 gap-1.5 p-4 text-center">
                        <IconPhoto size={36} className="text-amber-500/40" />
                        <span className="text-[11px] font-medium">Foto Tidak Tersedia</span>
                      </div>
                    )}

                    {/* Top Badges */}
                    <div className="absolute top-2.5 left-2.5 right-2.5 flex items-center justify-between gap-1.5 pointer-events-none">
                      {/* Cabang Badge */}
                      <span className="inline-flex items-center gap-1 bg-amber-600/90 hover:bg-amber-600 text-white text-[11px] font-extrabold px-2.5 py-1 rounded-lg backdrop-blur-md shadow-md border border-amber-400/30">
                        <span className="truncate max-w-[120px]">{storeName}</span>
                      </span>

                      <div className="flex items-center gap-1.5">
                        {/* Refund Badge */}
                        {Boolean(trx?.is_refund) && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded-lg text-[10px] font-black bg-rose-600 text-white shadow-md border border-rose-400/40">
                            Refund
                          </span>
                        )}

                        {/* Karat Badge */}
                        {trx?.karat && (
                          <span className="inline-flex items-center gap-1 bg-amber-600/90 hover:bg-amber-600 text-white text-[11px] font-extrabold px-2.5 py-1 rounded-lg backdrop-blur-md shadow border border-amber-400/30">
                            <IconDiamond size={11} />
                            {trx.karat} K
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Card Body */}
                  <div className="p-3.5 sm:p-4 flex flex-col flex-1 justify-between gap-3">
                    <div>
                      {/* Faktur & Date */}
                      <div className="flex items-center justify-between gap-1 mb-1.5 text-[11px]">
                        <button
                          type="button"
                          onClick={() => getIdPembelian(trx.id)}
                          className="font-mono font-bold text-amber-700 dark:text-amber-400 hover:underline flex items-center gap-1 cursor-pointer truncate max-w-[150px]"
                          title="Klik untuk melihat detail transaksi"
                        >
                          {trx?.kode_trx || '-'}
                        </button>
                        <span className="text-slate-400 dark:text-slate-500 text-[10px] font-bold">
                          {trx?.created_at
                            ? trx.created_at
                            : '-'}
                        </span>
                      </div>

                      {/* Item Category Title */}
                      <h4 className="font-bold text-sm text-slate-800 dark:text-slate-100 leading-snug line-clamp-1">
                        {trx?.jenis_kategori?.nama_jenis || 'Barang Pembelian'}
                      </h4>
                      {/* Specs Row */}
                      <div className="grid grid-cols-2 gap-2 mt-2.5 pt-2.5 border-t border-slate-100 dark:border-slate-800/80 text-xs">
                        <div className="flex items-center gap-1.5 text-slate-600 dark:text-slate-300">
                          <span className="font-bold text-slate-800 dark:text-slate-100">
                            Berat: {beratVal.toFixed(3)} gr | {trx.karat} K
                          </span>
                        </div>
                        <div className="flex items-center justify-end gap-1 text-[11px] text-slate-500 dark:text-slate-400">
                          <span>Rata2:</span>
                          <span className="font-bold text-slate-700 dark:text-slate-200">
                            Rp {numberWithCommas(avgPerGram)}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Footer: Gold Price & Kondisi Barang */}
                    <div className="pt-2 border-t border-slate-100 dark:border-slate-800/80 flex items-center justify-between gap-2">
                      <div>
                        <span className="text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider block">
                          Total Beli
                        </span>
                        <div className="flex items-center gap-1.5 flex-wrap">
                          <span
                            className={`text-sm sm:text-base font-black ${
                              trx?.is_refund
                                ? 'line-through text-slate-400 dark:text-slate-500'
                                : 'bg-gradient-to-r from-amber-600 to-amber-700 dark:from-amber-400 dark:to-amber-500 bg-clip-text text-transparent'
                            }`}
                          >
                            Rp {numberWithCommas(hargaBeli)}
                          </span>
                          {Boolean(trx?.is_refund) && (
                            <span className="text-[10px] font-bold text-rose-600 dark:text-rose-400 bg-rose-50 dark:bg-rose-950/50 px-1 py-0.2 rounded border border-rose-200 dark:border-rose-900/40">
                              Batal
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Kondisi Barang (Service, Rongsok, Ready Jual) */}
                      <div className="flex flex-col items-end">
                        <span className="text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider block mb-0.5">
                          Kondisi
                        </span>
                        {updatingId === trx.id ? (
                          <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-slate-100 dark:bg-slate-800 text-slate-500 text-xs font-semibold">
                            <IconLoader2 size={12} className="animate-spin text-amber-500" />
                            <span className="text-[11px]">Menyimpan...</span>
                          </div>
                        ) : (
                          <div className="relative inline-flex items-center">
                            <select disabled={true}
                              value={normalizeKondisi(trx?.kondisi_barang)}
                              onChange={(e) => handleKondisiChange(trx, e.target.value)}
                              className={`text-xs font-bold px-2.5 py-1 pr-6 rounded-lg border appearance-none cursor-pointer transition-all shadow-sm ${getKondisiBadgeStyle(
                                trx?.kondisi_barang
                              )}`}
                              title="Pilih kondisi barang: Ready Jual, Service, atau Rongsok"
                            >
                              <option
                                value="Ready Jual"
                                className="bg-white dark:bg-slate-800 text-emerald-700 dark:text-emerald-400 font-bold"
                              >
                                Ready Jual
                              </option>
                              <option
                                value="Service"
                                className="bg-white dark:bg-slate-800 text-sky-700 dark:text-sky-400 font-bold"
                              >
                                Service
                              </option>
                              <option
                                value="Rongsok"
                                className="bg-white dark:bg-slate-800 text-rose-700 dark:text-rose-400 font-bold"
                              >
                                Rongsok
                              </option>
                            </select>
                            <div className="absolute right-1.5 top-1/2 -translate-y-1/2 pointer-events-none text-current opacity-70">
                              <IconChevronDown size={12} />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* ========================================================================= */}
      {/* STICKY BOTTOM SUMMARY BAR (GOLD EXECUTIVE THEME)                         */}
      {/* ========================================================================= */}
      <div className="sticky bottom-0 z-20 bg-white/95 dark:bg-slate-900/95 backdrop-blur-md border-t border-slate-200 dark:border-slate-800 shadow-[0_-4px_20px_rgba(0,0,0,0.06)] px-4 sm:px-6 py-3 transition-colors">
        <div className="w-full flex flex-col md:flex-row items-center justify-between gap-3">
          {/* Metrics Summary Badges */}
          <div className="flex items-center gap-3 sm:gap-6 flex-wrap justify-center md:justify-start">
            {/* Total Pembelian */}
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-amber-500/10 dark:bg-amber-400/10 border border-amber-500/20">
              <span className="text-xs font-bold text-amber-700 dark:text-amber-300 uppercase tracking-wider">
                Total Beli (Hal):
              </span>
              <span className="text-xs sm:text-sm font-extrabold text-amber-600 dark:text-amber-400">
                Rp {numberWithCommas(totalHargaPage)}
              </span>
            </div>

            {/* Total Trx */}
            <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-600 dark:text-slate-300">
              <span className="text-slate-400 uppercase font-bold text-[11px]">Jumlah:</span>
              <span className="px-2 py-0.5 rounded-lg bg-slate-100 dark:bg-slate-800 font-bold text-slate-800 dark:text-slate-100">
                {trxPembelian.length} / {totalItems} trx
              </span>
            </div>

            {/* Total Berat */}
            <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-600 dark:text-slate-300">
              <span className="text-slate-400 uppercase font-bold text-[11px]">Berat:</span>
              <span className="px-2 py-0.5 rounded-lg bg-slate-100 dark:bg-slate-800 font-bold text-slate-800 dark:text-slate-100">
                {parseFloat(totalBeratPage || 0).toFixed(3)} gr
              </span>
            </div>
          </div>

          {/* Pagination Controls */}
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-slate-500 dark:text-slate-400">
              Hal {currentPage} dari {lastPage || 1}
            </span>
            <div className="flex items-center gap-1">
              <button
                type="button"
                onClick={() => {
                  if (currentPage > 1) setCurrentPage(currentPage - 1);
                }}
                disabled={currentPage <= 1}
                className="p-1.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 hover:border-amber-400 hover:text-amber-600 disabled:opacity-40 disabled:cursor-not-allowed transition cursor-pointer"
                title="Halaman Sebelumnya"
              >
                <IconChevronLeft size={16} />
              </button>
              <button
                type="button"
                onClick={() => {
                  if (currentPage < lastPage) setCurrentPage(currentPage + 1);
                }}
                disabled={currentPage >= lastPage}
                className="p-1.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 hover:border-amber-400 hover:text-amber-600 disabled:opacity-40 disabled:cursor-not-allowed transition cursor-pointer"
                title="Halaman Berikutnya"
              >
                <IconChevronRight size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
};

export default GaleriPembelian;